(() => {
  const quotes = document.querySelector('.quotes');
  const container = quotes.querySelector('.container');
  const pagination = quotes.querySelector('.pagination');
  const slides = [...quotes.querySelectorAll('.slide')];
  const points = [];
  let index = 0;

  if(slides.length <= 1) {
    return;
  }

  const handleClick = (i) => {
    index = i;
    container.style.left = `-${i}00%`;
    pagination.querySelector('.active').classList.remove('active');
    points[i].classList.add('active');
  };

  Array.from({ length: slides.length }).forEach((_, i) => {
    const point = document.createElement("div");
    point.classList.add('point');
    point.onclick = handleClick.bind(_, i);
    pagination.append(point);
    points.push(point);
  });

  setInterval(() => {
    handleClick(index === slides.length - 1 ? 0 : index + 1);
  }, 10000);

  container.style.minWidth = `${slides.length}00%`;
  points[index].classList.add('active');
})();
